<!-- <app-header [kleur]="onderneming?.kleur" [logo]="onderneming?.logo" [naam]="onderneming?.naam" [id]="onderneming?.id"></app-header> -->
<div class="container  align-items-center">
  <!-- <div class="card card-container  "> -->
    <div class="card-header" [ngStyle]="{'background-color': onderneming?.kleur }">
    </div>
    <div class="">
      <div class="row">
        <h1 class="col-10 cardHeader card-title text-left"><strong>Cash voor vakantiedagen</strong></h1>
        <div class="col-2 text-right mt-2">
          <a class="backButton" [routerLink]="['/',onderneming.naam,'tools']">
            <i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
          </a>
          
        </div>
       
      </div>
      <h6 class="card-subtitle mb-5 text-muted mobileTussentitel text-left">Bereken hoeveel een dag verlof u kost</h6>
      <div class="row">
        <div class="col-md-12">

          <form [formGroup]="brutoloonFormGroup" (ngSubmit)="onSubmitBruto();">
            <h4 class="mb-4  col-md-6 underlineTitle">Werknemer met een maandelijks brutoloon</h4>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="font-weight-bold" for="brutoloon">BRUTO MAANDWEDDE</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input formControlName="brutoloon" type="number"
                            name="brutoloon" step="any" placeholder="0.00" min=0
                            class="form-control" required>
                    </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="font-weight-bold" for="aantalDagen">AANTAL WERKDAGEN/WEEK</label>
                  
                      <input formControlName="aantalDagen" type="number"
                          name="aantalDagen" step="any" placeholder="0.00" min=0
                          class="form-control" required>
                 
              </div>
            </div>
        

            
            <div class="text-right">
              <button type="submit" 
              [disabled]="!brutoloonFormGroup.valid" class="btn btn-outline-secondary m-1">BEREKEN</button>
            </div>

          </form>

        </div>
        <div class="col xMargin">
          <div *ngIf="!calculateBruto" class="d-flex text-center w-100 h-100 " style="min-width: auto; min-height: 6em;">
            <div class="card-body d-flex align-items-center ">
              <p class="placeholder text-center w-100">vul het formulier in om resultaat te krijgen.</p>
            </div>
          </div>

          <div *ngIf="calculateBruto">
            <div  class=" text-center text-center w-100 d-flex h-100 my-auto mx-auto">
              <div class="kaderResultaat col-12 my-auto ">
                <h3 class="title" [ngStyle]="{'color': onderneming?.kleurKnoppen }" style="font-weight: bolder;">Bruto kost van 1 dag <i placement="top"
                  ngbTooltip={{holidayValue?.berekeningMaandloon}}
                  class="fa fa-question-circle backButton"  style=" font-size: 15px;"aria-hidden="true"></i></h3>
                <h2 class="mt-4">{{resultBruto | currency:'EUR'}}</h2>
              </div>
            </div>

              <!--Op aanvraag van besox: knop met "Vraag offerte aan" -->
            <div *ngIf="onderneming.naam == 'Besox'" class="w-100 mt-4 horizontalCenter d-flex mb-3">
              <div class="  ">
                <a type="button" href="https://www.besox.be/offerte-aanvragen/" class="pt-3 pb-3 btn btn-info btnOfferte">Vraag
                  offerte aan</a>
  
              </div>
            </div>
            
          </div>
          
        </div>
      </div>
<div class="border-top"></div>
      <div class="row ">
        <div class="col-md-12">

          <form [formGroup]="uurloonFormGroup" (ngSubmit)="onSubmitUur();">
            <h4 class="col-md-6 mb-4 underlineTitle ">Werknemer met een uurloon</h4>
            <div class="form-row">

                <div class="form-group col-md-6">
                    <label class="font-weight-bold" for="uurloon">UURLOON</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input formControlName="uurloon" type="number"
                            name="uurloon" step="any" placeholder="0.00" min=0
                            class="form-control" required>
                    </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="font-weight-bold" for="aantalUren">AANTAL UUR TE WERKEN/DAG</label>
                  
                      <input formControlName="aantalUren" type="number"
                          name="aantalUren" step="any" placeholder="0.00" min=0
                          class="form-control" required>
                 
              </div>
            </div>

            
            <div class="text-right">
              <button type="submit" 
              [disabled]="!uurloonFormGroup.valid" class="btn btn-outline-secondary m-1">BEREKEN</button>
            </div>

          </form>

        </div>
        <div class="col xMargin">
          <div *ngIf="!calculateUur" class="d-flex text-center w-100 h-100 " style="min-width: auto; min-height: 6em;">
            <div class="card-body d-flex align-items-center ">
              <p class="placeholder text-center w-100">vul het formulier in om resultaat te krijgen.</p>
            </div>
  
  
  
          </div >

          <div *ngIf="calculateUur">
            <div  class=" text-center w-100 d-flex h-100 my-auto mx-auto">
              <div class=" kaderResultaat col-12 mb-4">
                <h3 class="title" [ngStyle]="{'color': onderneming?.kleurKnoppen }"style="font-weight: bolder;">Bruto kost van 1 dag <i placement="top"
                  ngbTooltip={{holidayValue?.berekeningUurloon}}
                  class="fa fa-question-circle backButton "  style="font-size: 15px;"aria-hidden="true"></i></h3>
                <h2 class="mt-4">{{resultUur | currency:'EUR'}}</h2>
              </div>
            </div>
              <!--Op aanvraag van besox: knop met "Vraag offerte aan" -->
            <div *ngIf="onderneming.naam == 'Besox'" class="w-100 horizontalCenter d-flex mb-3">
              <div class="  ">
                <a type="button" href="https://www.besox.be/offerte-aanvragen/" class="pt-3 pb-3 btn btn-info btnOfferte">Vraag
                  offerte aan</a>
  
              </div>
            </div>
            
          </div>
         
        </div>
      </div>

      <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming?.kleur }"></div>
      <div class=" mt-4 row  h-100">
        <p class="text-center mx-auto font-italic">
          {{dataService.onderneming?.algemeneWaarschuwing }}
        </p>
      </div>


    </div>

  <!-- </div> -->
</div>
